
import { defineComponent } from "vue";
import { IHeadquartersModel } from "@/interfaces/modules/configuration/IHeadquartersModel";
import HeadquartersService from "@/api/Configuration/HeadquartersService";
import store from "@/store";
export default defineComponent({
  name: "App",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as IHeadquartersModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          {
            key: "Code",
            label: "Código DANE",
            sortable: true,
          },
          {
            key: "Description",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "Type",
            label: "Tipo sede",
            sortable: true,
          },
          {
            key: "Enable",
            label: "Activo",
            sortable: true,
          },
          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
            (item: any) =>
              item.Code.toLowerCase().includes(
                this.table.filters.search.toLowerCase()
              ) ||
              item.Description.toLowerCase().includes(
                this.table.filters.search.toLowerCase()
              ) ||
              item.Type.toLowerCase().includes(
                this.table.filters.search.toLowerCase()
              )
          )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await HeadquartersService.GetHeadquarters();
      this.table.loading = false;
    },
    async edit(data: IHeadquartersModel) {
      this.form.record = await HeadquartersService.GetHeadquartersbyId(data);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as IHeadquartersModel;
      this.form.dialog = true;
    },
    validateState(field: any): boolean {
      return this.form.record[field]?.length > 0 ? true : false;
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.form.dialog = false;
      await HeadquartersService.PostHeadquarters(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
